var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { Translate } from "../../../../../I18N";
import { createColumnHelper } from '@tanstack/react-table';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { EmbededButton, Button } from "../../../../Components/UI";


const EditButton = ({ cell, column }) => /*#__PURE__*/
_jsx(Button, {
  styling: "outline",
  onClick: () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Edit")
);


const TitleCell = ({ row, getValue }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
_jsx(Translate, {
  context: "Menu",
  className: row.getIsExpanded() ? 'text-indigo-900' : 'text-indigo-800' }, void 0,

getValue()
),
row.getCanExpand() && /*#__PURE__*/
_jsx(EmbededButton, {
  icon: row.getIsExpanded() ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {}),
  onClick: () => row.toggleExpanded(),
  color: "indigo" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Group")
)

);


const TitleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Label");
const URLHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "URL");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const columnHelper = createColumnHelper();
const columns = (actions) => [
columnHelper.accessor('title', {
  id: 'title',
  header: TitleHeader,
  cell: TitleCell,
  enableSorting: false,
  meta: { headerClassName: 'w-6/12' }
}),
columnHelper.accessor('url', {
  header: URLHeader,
  enableSorting: false,
  meta: { headerClassName: 'w-6/12' }
}),
columnHelper.accessor('key', {
  header: ActionHeader,
  cell: EditButton,
  enableSorting: false,
  meta: { action: actions.edit, headerClassName: 'sr-only invisible bg-gray-50' }
})];

export { EditButton, TitleHeader, URLHeader, TitleCell, columns };